import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import { Provider } from 'react-redux'
import {db} from './state';
import Raven from 'raven-js';
console.log('production?',process.env.NODE_ENV);
if (process.env.NODE_ENV === 'production')
  Raven.config('http://a4cfabbf64c745a7a5bcd974c1bc0dba@sentry.wotreplays.ru/10').install();

ReactDOM.render(
    <Provider store={db.store}>
        <App />
    </Provider>,
    document.getElementById('root')
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js